import React, {Component} from "react";
import { observer } from "mobx-react";
import {
    fn_closeDetailMemoView,
    fn_updateDetailMemo,
    fn_updateDetailMemoApi
} from "../../../../../function/FnBodyDetail";

@observer
class ShopMemoView extends Component {
    constructor(props) {
        super(props);
        this.inputFocus = React.createRef();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.inputFocus.current.focus();
    }

    render() {

        const { rootStore } = this.props;
        const viewStore = rootStore.viewStore;
        const order = viewStore.getOrderDetail;

        return(
            <div className={"layer_comm layer_common_type "+(viewStore.getDetailMemoView?' layer_open':'')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section_tit_comm">
                            <h1>매장메모 입력</h1>
                        </div>
                        <div className="section_textarea memo">{/*&#13;&#10;(매장메모는 주방주문서에만 출력됩니다)*/}
                        <textarea ref={this.inputFocus} value={order.shopMemo?order.shopMemo:''} placeholder="매장메모를 입력하세요"
                            onChange={event => fn_updateDetailMemo(rootStore, event.target.value)}
                        ></textarea>
                            <button type="button"
                                onClick={event => fn_updateDetailMemoApi(rootStore)}
                            >저장</button>
                        </div>
                        <div className="btn_close btn_close_comm">
                            <button
                                onClick={event => fn_closeDetailMemoView(rootStore)}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ShopMemoView;